var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"home-banner-item",attrs:{"href":_vm.data.link,"target":"_blank","title":_vm.data.title,"rel":"nofollow"}},[(_vm.data.img)?_c('ImgComponent',{attrs:{"img":_vm.data.img,"alt":_vm.data.img.alt}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }